import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { branchPillClass } from "@/lib/branches";
import { api } from "@/lib/api";
import {
  LayoutDashboard,
  Bell,
  Package,
  FileText,
  Wallet,
  Users,
  Building2,
  Truck,
  IdCard,
  UserCog,
  NotebookPen,
  Settings,
  ReceiptText,
  BookMinus,
  BookOpen,
  FileClock,
  AlertCircle,
  ClipboardPlus,
  PackageSearch,
  FileUp,
  FilePlus2,
  FileCheck2,
  Mailbox,
  ScrollText,
  HandCoins,
  Files,
  BellRing,
  Megaphone,
  Satellite,
  Archive,
  CalendarRange,
  CalendarDays,
  ClipboardCheck,
  ChevronDown,
  CalendarMinus,
  UsersRound,
  ShieldCheck,
  LogOut,
  Menu,
  X,
  FileSearch,
} from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { GlobalSearch } from "@/components/GlobalSearch";

export const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-dashboard", adminOnly: true },
  { to: "/ntc-profile", label: "NTC Profile", icon: Building2, testid: "nav-ntc-profile", adminOnly: true },
  { heading: "Operations" },
  { to: "/consignment-entry", label: "Consignment Entry", icon: ClipboardPlus, testid: "nav-consignment-entry" },
  { to: "/consignment-enquiry", label: "Consignment Enquiry", icon: PackageSearch, testid: "nav-consignment-enquiry" },
  { to: "/booking-report", label: "Booking Report", icon: CalendarRange, testid: "nav-booking-report" },
  { to: "/mis-report", label: "MIS Report", icon: FileText, testid: "nav-mis-report" },
  { to: "/delivery-report", label: "Delivery Report", icon: FileCheck2, testid: "nav-delivery-report" },
  { to: "/pod-upload", label: "POD Upload", icon: FileUp, testid: "nav-pod-upload" },
  { to: "/eway-bills", label: "E-Way Bills", icon: FileUp, testid: "nav-eway-bills" },
  { to: "/hire-challans", label: "Vehicle Hire Challan", icon: ScrollText, testid: "nav-hire-challans" },
  { to: "/market-vehicles", label: "Market Vehicle Engaged", icon: ScrollText, testid: "nav-market-vehicles" },
  { to: "/correction-log", label: "Correction Log Book", icon: FileClock, testid: "nav-correction-log" },
  { heading: "Billing" },
  { to: "/bill-create", label: "Bill Create", icon: FilePlus2, testid: "nav-bill-create", chennaiOnly: true },
  { to: "/bill-upload", label: "Bill Upload", icon: FileUp, testid: "nav-bill-upload", chennaiOnly: true },
  { to: "/bill-submission", label: "Bill Submission", icon: FileCheck2, testid: "nav-bill-submission", chennaiOnly: true },
  { to: "/bills", label: "Bills Print", icon: Files, testid: "nav-bills", chennaiOnly: true },
  { to: "/bill-enquiry", label: "Bill Enquiry", icon: FileSearch, testid: "nav-bill-enquiry" },
  { to: "/letter-of-account", label: "Letter of Account", icon: Mailbox, testid: "nav-letter-of-account" },
  { to: "/unbilled", label: "Unbilled Details", icon: FileClock, testid: "nav-unbilled" },
  { to: "/outstanding", label: "Outstanding Report", icon: AlertCircle, testid: "nav-outstanding" },
  { to: "/route-profit", label: "Route Profit", icon: HandCoins, testid: "nav-route-profit", adminOnly: true },
  { heading: "Accounts" },
  { to: "/receipts", label: "Money Receipt", icon: ReceiptText, testid: "nav-receipts" },
  { to: "/vouchers", label: "Debit Voucher", icon: BookMinus, testid: "nav-vouchers" },
  { to: "/bank-statement", label: "Bank Statement", icon: FileCheck2, testid: "nav-bank-statement", adminOnly: true },
  { to: "/expenses", label: "NTC Expenses", icon: Wallet, testid: "nav-expenses" },
  { to: "/customer-ledger", label: "Customer Ledger", icon: NotebookPen, testid: "nav-customer-ledger" },
  { to: "/vendor-ledger", label: "Vendor Ledger", icon: BookMinus, testid: "nav-vendor-ledger" },
  { to: "/day-book", label: "Branch Day Book", icon: BookOpen, testid: "nav-day-book" },
  { heading: "Masters" },
  { to: "/customers", label: "Customer Master", icon: Users, testid: "nav-customers" },
  { to: "/freight-master", label: "Freight Master", icon: HandCoins, testid: "nav-freight-master" },
  { to: "/vendor-master", label: "Vendor Master / Broker", icon: Building2, testid: "nav-vendor-master" },
  { to: "/vehicle-master", label: "Vehicle Master", icon: Truck, testid: "nav-vehicle-master" },
  { to: "/driver-master", label: "Driver Master", icon: UserCog, testid: "nav-driver-master" },
  { to: "/vehicles", label: "Company Vehicles", icon: Truck, testid: "nav-vehicles" },
  { to: "/asset-book", label: "NTC Asset Book", icon: Archive, testid: "nav-asset-book" },
  { to: "/log-book", label: "NTC Log Book", icon: BookOpen, testid: "nav-log-book" },
  { to: "/vehicles-tracking", label: "Vehicles Tracking", icon: Satellite, testid: "nav-vehicles-tracking" },
  { to: "/drivers", label: "Company Drivers", icon: IdCard, testid: "nav-drivers" },
  { to: "/stationary", label: "NTC Stationary", icon: NotebookPen, testid: "nav-stationary" },
  { heading: "Staff & HR" },
  { to: "/admin-panel", label: "Admin Panel", icon: ShieldCheck, testid: "nav-admin-panel", adminOnly: true },
  { to: "/staff-logins", label: "NTC Staff Logins", icon: UsersRound, testid: "nav-staff-logins", adminOnly: true },
  { to: "/staff-master", label: "NTC Staff Master", icon: UserCog, testid: "nav-staff-master", adminOnly: true },
  { to: "/attendance", label: "NTC Attendance", icon: ClipboardCheck, testid: "nav-attendance", adminOnly: true },
  { to: "/leave-applications", label: "Leave Application", icon: CalendarMinus, testid: "nav-leave-applications", adminOnly: true },
  { to: "/salaries", label: "NTC Staff Salary", icon: HandCoins, testid: "nav-salaries", adminOnly: true },
  { to: "/letter-pad", label: "NTC Letter Pad", icon: NotebookPen, testid: "nav-letter-pad", adminOnly: true },
  { to: "/ntc-calendar", label: "NTC Calendar", icon: CalendarDays, testid: "nav-ntc-calendar", adminOnly: true },
  { heading: "Other" },
  { to: "/reminders", label: "Reminders", icon: BellRing, testid: "nav-reminders" },
  { to: "/circulars", label: "NTC Circulars", icon: Megaphone, testid: "nav-circulars", adminOnly: true },
  { to: "/settings", label: "Settings", icon: Settings, testid: "nav-settings", adminOnly: true },
];

function DecisionBell() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!user || isAdmin) return;
    api
      .get("/market-vehicles")
      .then((r) => {
        const seen = localStorage.getItem("ntc_mv_seen") || "";
        setCount((r.data || []).filter((m) => m.status && m.status !== "Pending" && (m.decided_at || "") > seen).length);
      })
      .catch(() => {});
  }, [user, isAdmin]);
  if (!user || isAdmin) return null;
  return (
    <button
      type="button"
      title="Market vehicle request updates"
      onClick={() => {
        localStorage.setItem("ntc_mv_seen", new Date().toISOString());
        setCount(0);
        navigate("/market-vehicles");
      }}
      className="relative ml-auto grid h-9 w-9 place-items-center rounded-md text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800"
      data-testid="decision-bell"
    >
      <Bell className="h-5 w-5" />
      {count > 0 && (
        <span className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-red-600 px-1 text-[10px] font-bold text-white" data-testid="decision-bell-count">
          {count}
        </span>
      )}
    </button>
  );
}

function HeaderClock() {
  const [now, setNow] = useState(new Date());
  const [ro, setRo] = useState(localStorage.getItem("ntc_regional_office") || "South");
  useEffect(() => {
    api.get("/company-profile").then((r) => {
      const v = (r.data?.regional_office || "").trim();
      if (v) {
        setRo(v);
        localStorage.setItem("ntc_regional_office", v);
      }
      try {
        localStorage.setItem("ntc_branch_addresses", JSON.stringify(r.data?.branch_addresses || {}));
        localStorage.setItem("ntc_signature_image", r.data?.signature_image || "");
        localStorage.setItem("ntc_seal_image", r.data?.seal_image || "");
        localStorage.setItem("ntc_company_mobile", r.data?.mobile || "");
      } catch {}
    }).catch(() => {});
    api.get("/branch-contacts").then((r) => {
      try {
        localStorage.setItem("ntc_branch_phones", JSON.stringify(r.data || {}));
      } catch {}
    }).catch(() => {});
  }, []);
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const pad = (n) => String(n).padStart(2, "0");
  const dateTxt = `${pad(now.getDate())}-${MONTHS[now.getMonth()]}-${now.getFullYear()}`;
  const timeTxt = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  return (
    <>
      <span className="hidden whitespace-nowrap rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-bold text-slate-600 md:inline-block" data-testid="header-regional-office">
        Regional Office: <span className="text-primary">{ro}</span>
      </span>
      <span className="hidden whitespace-nowrap rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-bold tabular-nums text-slate-600 sm:inline-block" title="Today's date" data-testid="header-date">
        {dateTxt}
      </span>
      <span className="hidden whitespace-nowrap rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-bold text-slate-600 sm:inline-block" title="Today" data-testid="header-day">
        {DAYS[now.getDay()]}
      </span>
      <span className="hidden whitespace-nowrap rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-bold tabular-nums text-slate-600 sm:inline-block" title="Current time" data-testid="header-time">
        {timeTxt}
      </span>
      <span className="hidden whitespace-nowrap rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-bold tabular-nums text-slate-600 md:inline-block" title="Financial Year (Apr–Mar)" data-testid="header-fy">
        FY: <span className="text-primary">{now.getMonth() + 1 >= 4 ? `${now.getFullYear()}-${now.getFullYear() + 1}` : `${now.getFullYear() - 1}-${now.getFullYear()}`}</span>
      </span>
    </>
  );
}

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [blockedPages, setBlockedPages] = useState([]);
  const [allowedPages, setAllowedPages] = useState([]);
  const [crPending, setCrPending] = useState(0);
  useEffect(() => {
    api.get("/change-requests").then((r) => setCrPending((r.data || []).filter((x) => x.status === "Pending").length)).catch(() => {});
  }, [location.pathname]);
  useEffect(() => {
    if (user && user.role !== "admin" && location.pathname === "/" && !allowedPages.includes("/")) navigate("/consignment-entry", { replace: true });
  }, [user, location.pathname, navigate, allowedPages]);
  useEffect(() => {
    if (user && user.role !== "admin") {
      api.get("/my/blocked-pages").then((r) => {
        const d = r.data || {};
        setBlockedPages(Array.isArray(d) ? d : d.blocked || []);
        setAllowedPages(Array.isArray(d) ? [] : d.allowed || []);
      }).catch(() => {});
    } else {
      setBlockedPages([]);
      setAllowedPages([]);
    }
  }, [user]);
  const [collapsedSections, setCollapsedSections] = useState(() => {
    try { return new Set(JSON.parse(localStorage.getItem("ntc_nav_collapsed") || "[]")); } catch { return new Set(); }
  });
  const toggleSection = (h) =>
    setCollapsedSections((s) => {
      const n = new Set(s);
      n.has(h) ? n.delete(h) : n.add(h);
      localStorage.setItem("ntc_nav_collapsed", JSON.stringify([...n]));
      return n;
    });

  const doLogout = () => {
    logout();
    navigate("/login");
  };

  const SidebarInner = () => (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-3 px-6 py-6">
        <img
          src="/ntc-logo.jpg"
          alt="NTC logo"
          className="h-11 w-11 rounded-md object-contain bg-white"
          data-testid="sidebar-logo"
        />
        <div className="leading-tight">
          <div className="font-display text-base font-bold text-white">Nisha Transport</div>
          <div className="font-display text-base font-bold text-white">Corporation</div>
        </div>
      </div>

      <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-2">
        {(() => {
          let cur = null;
          return NAV.filter(
            (item) =>
              item.heading ||
              ((!item.adminOnly || user?.role === "admin" || (allowedPages.includes(item.to) && item.to !== "/admin-panel")) &&
                (!item.chennaiOnly || user?.role === "admin" || (user?.office || "Chennai") === "Chennai") &&
                !(user?.role !== "admin" && blockedPages.includes(item.to)))
          ).map((item) => {
            if (item.heading) {
              cur = item.heading;
              const isCollapsed = collapsedSections.has(item.heading);
              return (
                <button
                  key={item.heading}
                  type="button"
                  onClick={() => toggleSection(item.heading)}
                  className="flex w-full items-center justify-between px-3 pb-1 pt-4 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500 hover:text-slate-300"
                  data-testid={`nav-section-${item.heading.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  {item.heading}
                  <ChevronDown className={`h-3.5 w-3.5 transition-transform ${isCollapsed ? "-rotate-90" : ""}`} />
                </button>
              );
            }
            if (cur && collapsedSections.has(cur)) return null;
            const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.testid}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors duration-200 ${
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : "text-slate-300 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <Icon className="h-[18px] w-[18px]" />
              {item.label}
              {item.to === "/correction-log" && crPending > 0 && (
                <span className="ml-auto rounded-full bg-amber-500 px-1.5 py-0.5 text-[10px] font-bold leading-none text-white" data-testid="cr-pending-badge">{crPending}</span>
              )}
            </NavLink>
          );
          });
        })()}
      </nav>

      <div className="border-t border-white/10 px-3 py-4">
        <div className="mb-3 px-3">
          <div className="truncate text-sm font-medium text-white">{user?.name}</div>
          <div className="truncate text-xs text-slate-400">{user?.email}</div>
          <div className={`mt-1.5 inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${user?.role === "admin" ? "border-indigo-300 bg-indigo-50 text-indigo-700" : branchPillClass(user?.office || "Chennai")}`} data-testid="user-branch">
            <Building2 className="h-3 w-3" />
            {user?.role === "admin" ? "All Branches (Admin)" : user?.office || "No branch"}
          </div>
        </div>
        <button
          data-testid="logout-btn"
          onClick={doLogout}
          className="flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-slate-300 transition-colors duration-200 hover:bg-white/5 hover:text-white"
        >
          <LogOut className="h-[18px] w-[18px]" />
          Sign out
        </button>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen bg-background${user?.role === "admin" ? "" : " role-staff"}`}>
      {/* Desktop sidebar */}
      <aside className="fixed inset-y-0 left-0 z-40 hidden w-64 bg-[#0F172A] lg:block">
        <SidebarInner />
      </aside>

      {/* Mobile sidebar */}
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="absolute inset-y-0 left-0 w-64 bg-[#0F172A]">
            <button
              onClick={() => setOpen(false)}
              className="absolute right-3 top-4 text-slate-300 hover:text-white"
              data-testid="close-sidebar"
            >
              <X className="h-5 w-5" />
            </button>
            <SidebarInner />
          </aside>
        </div>
      )}

      <div className="lg:pl-64">
        <header className="sticky top-0 z-30 flex items-center gap-3 border-b border-border bg-white/80 px-4 py-3 backdrop-blur-md lg:px-8">
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={() => setOpen(true)}
            data-testid="open-sidebar"
          >
            <Menu className="h-5 w-5" />
          </Button>
          <div className="hidden text-xs uppercase tracking-[0.2em] text-muted-foreground md:block">
            Logistics Accounting Suite
          </div>
          <div className="flex min-w-0 items-center gap-1.5" data-testid="header-user-identity">
            <span className="shrink-0 whitespace-nowrap rounded-full bg-slate-900 px-2.5 py-1 text-xs font-bold tracking-wide text-white" title={`Logged in: ${user?.name || user?.user_id || ""}`} data-testid="header-staff-name">
              <span className="font-medium text-slate-300">Login: </span>
              {(() => { const n = user?.name || user?.user_id || "—"; return n === n.toUpperCase() ? n.toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase()) : n; })()}
            </span>
            <span className={`whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-bold ${user?.role === "admin" ? "border-indigo-300 bg-indigo-50 text-indigo-700" : branchPillClass(user?.office || "Chennai")}`} title="Login branch" data-testid="header-branch-name">
              <span className="font-medium opacity-70">Branch: </span>
              {user?.role === "admin" ? "All Branches" : user?.office || "Chennai"}
            </span>
            <HeaderClock />
          </div>
          <DecisionBell />
          <GlobalSearch />
        </header>
        <main className="px-4 py-6 lg:px-8 lg:py-8">
          {user?.role !== "admin" &&
          (blockedPages.includes(location.pathname) ||
            (NAV.some((i) => i.adminOnly && i.to === location.pathname) && (!allowedPages.includes(location.pathname) || location.pathname === "/admin-panel"))) ? (
            <div className="flex min-h-[50vh] flex-col items-center justify-center text-center" data-testid="page-blocked-msg">
              <h2 className="font-display text-xl font-bold text-slate-700">Option blocked</h2>
              <p className="mt-2 max-w-sm text-sm text-muted-foreground">This option has been blocked for your branch by the admin. Please contact Head Office if you need access.</p>
            </div>
          ) : (
            children
          )}
        </main>
      </div>
    </div>
  );
}
